<template>
  <v-progress-linear v-bind="$attrs" v-on="$listeners"></v-progress-linear>
</template>

<script>
export default {
  name: "BaseLinearProgress"
};
</script>
